<template>
    <div v-if="!isDeluxeLayout">
        <BreadcrumbsProject
        :breadcrumbs="[
            {
                link : dotnetUrl +'/project/list',
                title : $t('Projects'),
                isRouterLink: false
            },
            {
                link : projectUrl +'/Project/' + projectInfo._id,
                title :  (projectInfo.projectNumber || '-') +' ' + (projectInfo.projectName || ''),
                isRouterLink: false
            },
            {
                link : '/boq/' + projectInfo._id,
                title : $t('Bill of Quantities'),
                isRouterLink: true
            }
        ]"
        ></BreadcrumbsProject>
    </div>
    <div >
        <StepItem2 :active-index="isDeluxeLayout ? 1 : null" :deluxe="isDeluxeLayout"></StepItem2>
    </div>
    <div
        v-if="isDeluxeLayout"
        class="deluxe-project-back"
    >
        <a :href="projectUrl + '/project/' + projectInfo._id">
            <i class="fa-solid fa-chevron-left"></i> {{ $t('Back to Project Dashboard') }}
        </a>
    </div>
    <div
        v-if="isDeluxeLayout"
        class="deluxe-page-header"
    >
        <div class="deluxe-page-heading">
            <h1 class="deluxe-page-title">{{ $t('Bill of Quantity')}}</h1>
            <p><i>{{ $t('All monetary figures shown below are in') }} <strong>{{ currencyLabel }}</strong> {{ $t('and are exclusive of tax.') }}</i></p>
        </div>
        <form class="deluxe-page-tools boq-filter-toolbar" @submit.prevent>
            <div class="deluxe-transaction-search">
                <input
                    type="search"
                    v-model.trim="searchBar"
                    :placeholder="$t('Search Transaction')"
                    @keydown.enter.prevent
                    @search="QueueBoqSearch(searchBar)"
                />
                <button type="button" tabindex="-1" aria-hidden="true">
                    <i class="fa-solid fa-magnifying-glass"></i>
                </button>
            </div>
            <select class="deluxe-status-select" v-model="statusFilter">
                <option value="">{{ $t('Any Status') }}</option>
                <option
                    v-for="(stage, index) in ApprovalStageBoqObj"
                    :key="index"
                    :value="String(index + 1)"
                >
                    {{ stage.name }}
                </option>
            </select>
            <button type="button" class="deluxe-filter-button" :title="$t('Filter')" @click="SearchBoqs">
                <i class="fa-solid fa-filter"></i>
            </button>
            <button
                v-if="permission.indexOf(ModuleActionList.BOQ_CREATE)>-1"
                type="button"
                class="custom-btn"
                data-bs-toggle="modal"
                data-bs-target="#BoqModalAdd"
                @click="OpenCreate"
            >
                <span>{{ $t('Add BOQ') }}</span>
                <i class="fa-solid fa-plus"></i>
            </button>
            <ButtonTemplateDownloader
                standard
                group-class="boq-template-toolbar-group"
                button-class="custom-btn boq-filter-toolbar__template"
            />
            <button
                v-if="selected.length>1&&permission.indexOf(ModuleActionList.BOQ_CREATE)>-1"
                type="button"
                class="custom-btn custom-btn--cancel"
                data-bs-toggle="modal"
                data-bs-target="#BoqCombineModal"
                @click="OpenCombineModal"
            >
                <span>Combine BoQ</span>
                <i class="fa-solid fa-file-circle-plus"></i>
            </button>
            <button
                v-if="permission.indexOf(ModuleActionList.BOQ_CREATE) >-1"
                type="button"
                class="deluxe-filter-button boq-filter-toolbar__upload"
                data-bs-toggle="modal"
                data-bs-target="#BoqImportOfficeTemplates"
                @click="OpenOfficeImport"
                :title="$t('Import Office Template')"
            >
                <i class="fa-solid fa-upload"></i>
            </button>
        </form>
    </div>
    <div :class="{ 'border-top border-bottom': !isDeluxeLayout, 'boq-deluxe-list': isDeluxeLayout }">
        <div class="card">
            <div class="card-header bg-white" v-if="!isDeluxeLayout">
                <div class="d-flex justify-content-between">
                        <div >
                            <h6 class="fw-bold">{{ $t('Bill of Quantities')}}</h6>
                        </div>
                        <div class="">
                            <button class="btn btn-primary me-1" 
                            data-bs-toggle="modal" data-bs-target="#BoqModalAdd" @click="OpenCreate"
                            ><i class="fa-solid fa-plus"></i> {{ $t('Add BoQ') }}</button>

                            <button class="btn btn-primary me-1" v-if="selected.length>1&&permission.indexOf(ModuleActionList.BOQ_CREATE)>-1"
                            data-bs-toggle="modal" data-bs-target="#BoqCombineModal" @click="OpenCombineModal"
                            ><i class="fa-solid fa-file-circle-plus"></i> Combine BoQ</button>
                            <button class="btn btn-default me-1  pe-2 ps-2"
                            data-bs-toggle="modal" data-bs-target="#BoqImportOfficeTemplates"
                            v-if="permission.indexOf(ModuleActionList.BOQ_CREATE) >-1"
                            @click="OpenOfficeImport" 
                            :title="$t('Import Office Template')"><i class="fa-solid fa-upload"></i>  </button>
                        </div>
                    </div>
            </div>            
            <div class="card-body">
                <div class="row mb-3" v-if="!isDeluxeLayout">
                    
                    <div class="col-md-12 ps-2">
                        <input class="form-control" v-model="searchBar" :placeholder="$t('Search Here')" @keyup="searchRun($event.target.value)" />
                    </div>
                </div>
                
                <Loader v-if="tableIsLoading"></Loader>
                <div v-else class="table-responsive">
                    <TableBoq  :GetBoq="GetBoq" :search="appliedSearchBar" :DeleteBoq="DeleteBoq"
                    :CreateDuplicate="OpenDuplicateModal" :UpdateSelectedValue="UpdateSelectedValue"
                    :statusFilter="appliedStatusFilter"></TableBoq>
                </div>
            </div>
        </div>
    </div>
    <div v-if="isDeluxeLayout && !tableIsLoading" class="boq-table-pagination">
        <Pagination
        :changePage="ChangeBoqPage"
        :paginationDetails="paginationDetails"
        :havePageCount="true"
        :textControls="true"
        ></Pagination>
    </div>
    <Modal idModal="BoqModalAdd" :headerTitle="$t('Add Bill of Quantity')" modalSize="modal-md" v-if="permission.indexOf(ModuleActionList.BOQ_CREATE)>-1">
        <div class="boq-add-modal__project">
            <label>{{ $t('Project') }}</label>
            <input class="form-control" :value="projectInfo.projectNumber || '-'" readonly />
        </div>
        <div class="boq-add-modal__fields">
            <div class="form-group">
                <label>{{ $t('Name') }} <span v-if="saveClicked && !boqName">({{ $t('Required').toLowerCase() }})</span></label>
                <input class="form-control" :placeholder="$t('Enter Name')" v-model="boqName" />
            </div>
            <div class="form-group">
                <label class="boq-reference-label">{{ $t('Reference') }} <span class="boq-reference-note">( {{ $t('Links this BoQ to the quotation it is based on.') }} )</span></label>
                <Select2
                indexValue="_id"
                labelName="fullname"
                :placeHolder="$t('Select Reference')"
                v-model:optionValue="boqRef"
                :dataOptions="quotationReferenceList"
                disabledProperty="isReferenceDisabled"
                disabledRemarkProperty="referenceOptionRemark"
                :willCapitalize="false"
                />
            </div>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeAddModal" class="boq-modal-action boq-modal-action--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button type="button" class="boq-modal-action boq-modal-action--primary" @click="CreateBoq($event.target)" >{{ $t('Save and Proceed to Create') }}</button>
        </template>
    </Modal>
    <Modal idModal="BoqModalUpdate" :headerTitle="$t('Update BoQ')" modalSize="modal-md" v-if="permission.indexOf(ModuleActionList.BOQ_EDIT)>-1">
        <div class="boq-add-modal__project">
            <label>{{ $t('Project') }}</label>
            <input class="form-control" :value="projectInfo.projectNumber || '-'" readonly />
        </div>
        <div class="boq-add-modal__fields">
            <div class="form-group">
                <label>{{ $t('Name') }} <span v-if="updateClicked && !boqNameUpdate">({{ $t('Required').toLowerCase() }})</span></label>
                <input class="form-control" :placeholder="$t('Enter Name')" v-model="boqNameUpdate" />
            </div>
            <div class="form-group">
                <label class="boq-reference-label">{{ $t('Reference') }} <span class="boq-reference-note">( {{ $t('Links this BoQ to the quotation it is based on.') }} )</span></label>
                <Select2
                indexValue="_id"
                labelName="fullname"
                :placeHolder="$t('Select Reference')"
                v-model:optionValue="boqRefUpdate"
                :dataOptions="quotationReferenceList"
                disabledProperty="isReferenceDisabled"
                disabledRemarkProperty="referenceOptionRemark"
                :willCapitalize="false"
                />
            </div>
        </div>
        
        <template v-slot:actions>
            <button type="button" ref="closeUpdateModal" class="boq-modal-action boq-modal-action--cancel" data-bs-dismiss="modal">{{ $t('Cancel') }}</button>
            <button type="button" class="boq-modal-action boq-modal-action--primary" @click="UpdateBoq($event.target)" >{{ $t('Save') }}</button>
        </template>
    </Modal>
    <Modal idModal="BoqModalCreateDuplicate" :headerTitle="$t('Duplicate BoQ')" modalSize="modal-md" v-if="permission.indexOf(ModuleActionList.BOQ_DUPLIDATE)>-1">
        <div class="form-group">
            <label>{{$t('Parent Bill of Quantity')}}</label>
            <input class="form-control-plaintext text-capitalize" readonly v-model="boqDuplicatedName" />
        </div>
        <div class="form-group">
            <label class="required-style">{{$t('Name')}} </label>
            <input class="form-control" :placeholder="$t('Name')" v-model="boqDuplicate.boqName" />
            <small class="text-warning" v-if="duplicateClicked && !boqDuplicate.boqName">{{ $t('Required') }}</small>
        </div>
        <div class="form-group">
            <label class="boq-reference-label">{{ $t('Reference') }} <span class="boq-reference-note">( {{ $t('Links this BoQ to the quotation it is based on.') }} )</span></label>
            <Select2
            indexValue="_id"
            labelName="fullname"
            :placeHolder="$t('Search Here')"
            v-model:optionValue="boqDuplicate.boqRef"
            :dataOptions="quotationReferenceList"
            disabledProperty="isReferenceDisabled"
            disabledRemarkProperty="referenceOptionRemark"
            :willCapitalize="false"
            />
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeDuplicateModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">X {{$t('Cancel')}}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" @click="DuplicateBoq($event.target)" ><i class="fa-solid fa-copy"></i> {{$t('Duplicate')}}</button>
        </template>
    </Modal>
    <Modal idModal="BoqCombineModal" headerTitle="Combine BoQ" modalSize="modal-md" v-if="permission.indexOf(ModuleActionList.BOQ_CREATE)>-1">
        <small class="text-primary">*Selected Boq will be Merged Into a New BoQ</small> <br/>
        <div class="form-group">
            <label class="required-style">Name </label>
            <input class="form-control" :placeholder="$t('Name')" v-model="boqCombine.boqName" />
            <small class="text-warning" v-if="combineClicked && !boqCombine.boqName">{{ $t('Required') }}</small>
        </div>
        <div class="form-group">
            <label class="boq-reference-label">{{ $t('Reference') }} <span class="boq-reference-note">( {{ $t('Links this BoQ to the quotation it is based on.') }} )</span></label>
            <Select2
            :filterQuery="()=>{}"
            indexValue="_id"
            labelName="fullname"
            placeHolder="Search Quotation here"
            v-model:optionValue="boqCombine.boqRef"
            :dataOptions="quotationReferenceList"
            disabledProperty="isReferenceDisabled"
            disabledRemarkProperty="referenceOptionRemark"
            :willCapitalize="false"
            />
        </div>
        <div class="form-group">
            <label>Selected Count</label>
            <input class="form-control-plaintext text-capitalize" readonly :value="boqCombine.selectedCount"/>
            <small class="text-warning" v-if="boqCombine.selectedCount==0">No Selected Boq</small>
        </div>
        <template v-slot:actions>
            <button type="button" ref="closeCombineModal" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">X Cancel</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" v-if="boqCombine.selectedCount!=0" @click="CombineBoqRun"><i class="fa-solid fa-file-circle-plus"></i> Combine</button>
        </template>
    </Modal>
    <Modal idModal="BoqImportOfficeTemplates" :headerTitle="$t('Import Office Template')" modalSize="modal-md" v-if="permission.indexOf(ModuleActionList.BOQ_CREATE)>-1">
        <div class="hle-import-modal hle-office-import-modal">
            <div class="form-group hle-import-modal__field">
                <label class="required-style">{{$t('File')}} </label>
                <input type="file" ref="uploadFileOfficeTemplate" class="form-control hle-import-modal__input" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" />
                <small class="text-warning" v-if="isImportClicked && !boqOfficeTemplate.file">{{ $t('Required') }}</small>
            </div>
            <div class="form-group hle-import-modal__field">
                <label class="required-style">{{$t('Template Name')}} </label>
                <select class="form-select hle-import-modal__input" v-model="boqOfficeTemplate.templateType">
                    <option value="">{{ $t('Select Template') }}</option>
                    <option value="1">Kuala Lumpur {{ $t('Office Template') }}</option>
                    <option value="2">India {{ $t('Office Template') }}</option>
                    <option value="3">Manila {{ $t('Office Template') }}</option>
                </select>
                <small class="text-warning" v-if="isImportClicked && !boqOfficeTemplate.templateType">{{ $t('Required') }}</small>
            </div>
            <div class="form-group hle-import-modal__field">
                <label class="boq-reference-label required-style">{{ $t('Reference') }} <span class="boq-reference-note">( {{ $t('Links this BoQ to the quotation it is based on.') }} )</span></label>
                <Select2
                indexValue="_id"
                labelName="fullname"
                placeHolder="Search Quotation here"
                v-model:optionValue="boqOfficeTemplate.boqRef"
                :dataOptions="quotationReferenceList"
                disabledProperty="isReferenceDisabled"
                disabledRemarkProperty="referenceOptionRemark"
                :willCapitalize="false"
                />
                <small class="text-warning" v-if="isImportClicked && !boqOfficeTemplate.boqRef">{{ $t('Required') }}</small>
            </div>
        </div>
        <!-- <div class="form-group" >
            <label>Upload Progress</label>
            <div class="progress">
            <div class="progress-bar"
            :class="{ 'progress-bar-striped progress-bar-animated' : uploadPercentage < 100, 'bg-success' : uploadPercentage == 100 }"
             role="progressbar" :style="{ 'width' : uploadPercentage + '%' }" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">{{uploadPercentage}}%</div>
            </div>
            <small class="text-info">{{uploadMessage}}</small>
        </div> -->
        <template v-slot:actions>
            <button type="button" ref="closeBoqImportOfficeTemplates" :class="isDeluxeLayout ? 'custom-btn custom-btn--cancel' : 'btn btn-outline-danger'" data-bs-dismiss="modal">{{ isDeluxeLayout ? $t('Cancel') : 'X ' + $t('Cancel') }}</button>
            <button type="button" :class="isDeluxeLayout ? 'custom-btn' : 'btn btn-primary'" :disabled="isImportRunning"  @click="UploadOfficeTemplate" ><i class="fa-solid fa-upload"></i> {{$t('Import')}}</button>
        </template>
    </Modal>
</template>


<script src="@/assets/boq/BoqList.js" />

<style scoped>
.boq-deluxe-list .table-responsive,
.boq-deluxe-list :deep(.boq-list-table),
.boq-deluxe-list :deep(.boq-list-table th),
.boq-deluxe-list :deep(.boq-list-table td) {
    border-radius: 0 !important;
}
</style>
